/* eslint-disable */
// TODO: Remove previous line and work through linting issues at next edit

module.exports = {
  CHINESE: require('./chinese'),
  ENGLISH: require('./english'),
  FRENCH: require('./french'),
  ITALIAN: require('./italian'),
  JAPANESE: require('./japanese'),
  SPANISH: require('./spanish'),
};
